import Card from '../../components/Card';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../../context/AuthContext';
import heroBg from '../../assets/sas_hero_new.png';
import { motion } from 'framer-motion';
import HeroBackground from '../../components/ui/HeroBackground';
import { useT } from '../../utils/useTranslation';
import logo from '../../assets/logo.jpeg';
import { db, auth } from '../../firebase';
import { collection, query, where, getDocs, doc, updateDoc } from 'firebase/firestore';
import { sendPasswordResetEmail } from 'firebase/auth';

export default function LoginPage() {
  const t = useT();
  const isRTL = t.language === 'sindhi';
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  // Forgot Password State
  const [showResetModal, setShowResetModal] = useState(false);
  const [resetForm, setResetForm] = useState({
    email: '',
  });
  const [resetLoading, setResetLoading] = useState(false);

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setResetLoading(true);
    try {
      await sendPasswordResetEmail(auth, resetForm.email);
      toast.success(isRTL ? "پاسورڊ ري سيٽ لنڪ توهان جي اي ميل تي موڪلي وئي آهي." : "Password reset link has been sent to your email.");
      setShowResetModal(false);
    } catch (err) {
      console.error(err);
      toast.error(err.code === 'auth/user-not-found' ? (isRTL ? 'اي ميل نه ملي وئي' : 'Email not found') : t('error'));
    } finally {
      setResetLoading(false);
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      toast.success(`${t('welcomeTitle')}, ${user.displayName || user.name}!`);
      navigate('/admin');
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || t('loginFailed'));
    } finally {
      setLoading(false);
    }
  };

  return <div style={{
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative'
  }}>
    <HeroBackground />

    <div style={{
      position: 'relative',
      zIndex: 10,
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 16px'
    }}>
      <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} style={{
        width: '100%',
        maxWidth: 420
      }}>
        {/* Logo */}
        <div style={{
          textAlign: 'center',
          marginBottom: 32
        }}>
          <img src={logo} alt="Logo" style={{
            width: 100,
            height: 100,
            borderRadius: 24,
            margin: '0 auto 20px',
            display: 'block',
            border: '3px solid var(--sindhi-gold)',
            boxShadow: '0 15px 35px rgba(0,0,0,0.4)',
            objectFit: 'cover'
          }} />
          <h1 style={{
            fontFamily: 'var(--font-display)',
            fontSize: 28,
            fontWeight: 800,
            color: 'white',
            letterSpacing: -0.5
          }}>
            {t('loginTitle')}
          </h1>
          <p style={{
            fontSize: 15,
            color: 'rgba(255,255,255,0.6)',
            marginTop: 8
          }}>{t('loginSubtitle')}</p>
        </div>

        {/* Form card */}
        <Card style={{
          padding: 40,
          background: 'rgba(255,255,255,0.05)',
          border: '1px solid rgba(255,255,255,0.1)'
        }}>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label" style={{
                color: 'rgba(255,255,255,0.8)'
              }}>{t('emailAddress')}</label>
              <input className="form-input" type="email" placeholder={t('emailPlaceholder')} style={{
                background: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.1)',
                color: 'white'
              }} value={form.email} onChange={e => setForm({
                ...form,
                email: e.target.value
              })} required />
            </div>
            <div className="form-group">
              <label className="form-label" style={{
                color: 'rgba(255,255,255,0.8)'
              }}>{t('password')}</label>
              <input className="form-input" type="password" placeholder={t('passwordPlaceholder')} style={{
                background: 'rgba(255,255,255,0.08)',
                border: '1px solid rgba(255,255,255,0.1)',
                color: 'white'
              }} value={form.password} onChange={e => setForm({
                ...form,
                password: e.target.value
              })} required />
              
              <div style={{ textAlign: isRTL ? 'left' : 'right', marginTop: 8 }}>
                <button type="button" onClick={() => setShowResetModal(true)} style={{
                  background: 'none', border: 'none', color: 'var(--sindhi-gold)',
                  fontSize: 12, cursor: 'pointer', fontWeight: 600, padding: 0
                }}>
                  {t('forgotPassword')}
                </button>
              </div>
            </div>
            <p style={{fontSize: 12, color: 'rgba(255,255,255,0.5)', marginTop: '1rem', textAlign: 'center'}}>Use password: <strong>password123</strong> for seeded test accounts.</p>
            <button type="submit" className="btn btn-primary" style={{
              width: '100%',
              justifyContent: 'center',
              padding: '14px',
              marginTop: 16,
              fontSize: 16
            }} disabled={loading}>
              {loading ? t('signingIn') : t('signIn')}
            </button>
          </form>

          <div style={{
            textAlign: 'center',
            marginTop: 28,
            fontSize: 14,
            color: 'rgba(255,255,255,0.5)'
          }}>
            {t('notAMember')}{' '}
            <Link to="/register" style={{
              color: 'var(--sindhi-gold)',
              fontWeight: 700,
              textDecoration: 'none'
            }}>
              {t('registerNow')}
            </Link>
          </div>
        </Card>

        <div style={{
          textAlign: 'center',
          marginTop: 24
        }}>
          <Link to="/" style={{
            fontSize: 14,
            color: 'rgba(255,255,255,0.6)',
            textDecoration: 'none',
            fontWeight: 500
          }}>{t('backToWebsite')}</Link>
        </div>
      </motion.div>
    </div>

    {/* Reset Password Modal */}
    {showResetModal && (
      <div style={{
        position: 'fixed', inset: 0, zIndex: 1000,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'rgba(10,25,47,0.9)', backdropFilter: 'blur(10px)',
        padding: 20
      }}>
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} style={{
          width: '100%', maxWidth: 450
        }}>
          <Card style={{
            padding: 40, background: 'rgba(255,255,255,0.05)',
            border: '1px solid var(--sindhi-gold)', boxShadow: '0 30px 60px rgba(0,0,0,0.5)'
          }}>
            <h2 style={{ color: 'white', marginBottom: 24, fontSize: 24, fontWeight: 800, textAlign: 'center' }}>
              {t('resetPassword')}
            </h2>
            <form onSubmit={handleResetPassword}>
              <div className="form-group">
                <label className="form-label" style={{ color: 'white' }}>{t('emailAddress')}</label>
                <input className="form-input" type="email" placeholder="email@example.com" required
                  style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.1)', color: 'white' }}
                  value={resetForm.email} onChange={e => setResetForm({...resetForm, email: e.target.value})} />
              </div>
              
              <div style={{ display: 'flex', gap: 12, marginTop: 32 }}>
                <button type="button" onClick={() => setShowResetModal(false)} className="btn" style={{ flex: 1, background: 'rgba(255,255,255,0.1)', color: 'white' }}>
                  {t('cancel')}
                </button>
                <button type="submit" className="btn btn-primary" disabled={resetLoading} style={{ flex: 2 }}>
                  {resetLoading ? t('loading') : t('resetPassword')}
                </button>
              </div>
            </form>
          </Card>
        </motion.div>
      </div>
    )}
  </div>;
}
